import React, { useEffect, useState } from 'react';
import ProjectsHeader from '../components/ProjectsHeader';
import NavigationMenu from '../components/NavigationMenu';
import MainContentArea from '../components/MainContentArea';
import ProjectsNavMenu from '../components/ProjectsNavMenu';
import { useAuth } from '../contexts/AuthContext';
import { useNotifications } from '../contexts/NotificationsContext';
import { buildMainNavLinks } from '../utils/mainNavLinks';
import './ProjectsLayout.css';

const ProjectsLayout = ({ children, title = '' }) => {
  const { totalCount: horizonBadge, reviewCount, embeddingCount, schedulerErrorCount } = useNotifications();
  const { user } = useAuth();
  // Initialize from cookie to avoid flicker and ensure consistency across pages
  const getInitialOpen = () => {
    try {
      const match = document.cookie.match(/(?:^|; )nav_open=([^;]*)/);
      if (match) {
        const v = decodeURIComponent(match[1]);
        return v === '1' || v === 'true';
      }
    } catch (_) {}
    return false;
  };
  const [isMenuOpen, setIsMenuOpen] = useState(getInitialOpen);
  const [disableAnim, setDisableAnim] = useState(true);

  useEffect(() => {
    // Enable animations after first paint; initial render reflects cookie state without animation
    const id = requestAnimationFrame(() => setDisableAnim(false));
    return () => cancelAnimationFrame(id);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen((prev) => {
      const next = !prev;
      try {
        // Persist for ~180 days
        document.cookie = `nav_open=${next ? '1' : '0'}; path=/; max-age=15552000`;
      } catch (_) {}
      return next;
    });
  };

  // Projects page should only show default navigation items (Projects, Settings)

  return (
    <div className="projects-layout">
      <ProjectsHeader
        isMenuOpen={isMenuOpen}
        onToggle={toggleMenu}
        title={title}
      />
      <div className="projects-container">
        <NavigationMenu
          isOpen={isMenuOpen}
          onToggle={toggleMenu}
          disableTransition={disableAnim}
          linkItems={buildMainNavLinks({ user, horizonBadge, embeddingCount, reviewCount, schedulerErrorCount })}
          extraContent={<ProjectsNavMenu />}
        />
        <MainContentArea isMenuOpen={isMenuOpen} disableTransition={disableAnim}>
          <div className="projects-main-content">
            {children}
          </div>
        </MainContentArea>
      </div>
    </div>
  );
};

export default ProjectsLayout;
